import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE || process.env.REACT_APP_API_URL || 'http://localhost:8002',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
